import { useContext } from 'react'
import { createCtx } from '../../../context/_createCtx'
import { UserFormContextValues } from '../_props'

export const defaultValues: UserFormContextValues = {
    annData: undefined,
    isLoading: false,
    shouldBlockNavigation: false,
    isSaving: false,
    loaderMessage: "Chargement des informations de l'utilisateur...",
    isEditionMode: false,
    rppsLocked: false,
    redirectKey: undefined,
}

const [ctx, provider] = createCtx(defaultValues)

export const UserFormContextProvider = provider

export const useUserFormContext = () => useContext(ctx)
